// Generated by purs version 0.13.5
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Except_Trans = require("../Control.Monad.Except.Trans/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Generic_Rep_Show = require("../Data.Generic.Rep.Show/index.js");
var Data_Identity = require("../Data.Identity/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Foreign = require("../Foreign/index.js");
var Foreign_Generic_Class = require("../Foreign.Generic.Class/index.js");
var Foreign_Index = require("../Foreign.Index/index.js");
var Foreign_Object = require("../Foreign.Object/index.js");
var Indexer_MTime = require("../Indexer.MTime/index.js");
var Node_Path = require("../Node.Path/index.js");
var Dir = (function () {
    function Dir(value0) {
        this.value0 = value0;
    };
    Dir.create = function (value0) {
        return new Dir(value0);
    };
    return Dir;
})();
var File = (function () {
    function File(value0) {
        this.value0 = value0;
    };
    File.create = function (value0) {
        return new File(value0);
    };
    return File;
})();
var unwrapFile = function (dictPartial) {
    return function (v) {
        if (v instanceof File) {
            return v.value0;
        };
        throw new Error("Failed pattern match at Indexer.FSEntry (line 26, column 1 - line 26, column 44): " + [ v.constructor.name ]);
    };
};
var label = function (dictPartial) {
    return function (v) {
        if (v instanceof File) {
            var dropPreviewPrefix = function (n) {
                return Data_Maybe.fromMaybe(n)(Data_String_CodeUnits.stripPrefix("gh-pages-preview-")(n));
            };
            var dropExt = function (n) {
                return Node_Path.basenameWithoutExt(n)(Node_Path.extname(n));
            };
            var cleanup = function ($60) {
                return dropPreviewPrefix(dropExt($60));
            };
            return cleanup(v.value0.basename);
        };
        throw new Error("Failed pattern match at Indexer.FSEntry (line 29, column 1 - line 29, column 38): " + [ v.constructor.name ]);
    };
};
var genericFSEntry = new Data_Generic_Rep.Generic(function (x) {
    if (x instanceof Dir) {
        return new Data_Generic_Rep.Inl(x.value0);
    };
    if (x instanceof File) {
        return new Data_Generic_Rep.Inr(x.value0);
    };
    throw new Error("Failed pattern match at Indexer.FSEntry (line 37, column 1 - line 37, column 52): " + [ x.constructor.name ]);
}, function (x) {
    if (x instanceof Data_Generic_Rep.Inl) {
        return new Dir(x.value0);
    };
    if (x instanceof Data_Generic_Rep.Inr) {
        return new File(x.value0);
    };
    throw new Error("Failed pattern match at Indexer.FSEntry (line 37, column 1 - line 37, column 52): " + [ x.constructor.name ]);
});
var showFSEntry = new Data_Show.Show(function (x) {
    return Data_Generic_Rep_Show.genericShow(genericFSEntry)(Data_Generic_Rep_Show.genericShowSum(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "basename";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "content";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "dirname";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showArray(showFSEntry)))(Data_Show.showString))))(new Data_Symbol.IsSymbol(function () {
        return "Dir";
    })))(Data_Generic_Rep_Show.genericShowConstructor(Data_Generic_Rep_Show.genericShowArgsArgument(Data_Show.showRecord()(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "basename";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "dirname";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "mtime";
    }))(Data_Show.showRecordFieldsCons(new Data_Symbol.IsSymbol(function () {
        return "size";
    }))(Data_Show.showRecordFieldsNil)(Data_Show.showNumber))(Indexer_MTime.showMTime))(Data_Show.showString))(Data_Show.showString))))(new Data_Symbol.IsSymbol(function () {
        return "File";
    }))))(x);
});
var eqFSEntry = new Data_Eq.Eq(function (v) {
    return function (v1) {
        if (v instanceof File && v1 instanceof File) {
            return v.value0.dirname === v1.value0.dirname && label()(v) === label()(v1);
        };
        if (v instanceof Dir && v1 instanceof Dir) {
            return Data_Eq.eq(Data_Eq.eqRec()(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowCons(Data_Eq.eqRowNil)()(new Data_Symbol.IsSymbol(function () {
                return "dirname";
            }))(Data_Eq.eqString))()(new Data_Symbol.IsSymbol(function () {
                return "content";
            }))(Data_Eq.eqArray(eqFSEntry)))()(new Data_Symbol.IsSymbol(function () {
                return "basename";
            }))(Data_Eq.eqString)))(v.value0)(v1.value0);
        };
        return false;
    };
});
var ordFSEntry = new Data_Ord.Ord(function () {
    return eqFSEntry;
}, function (f1) {
    return function (f2) {
        var toCompare = function (v) {
            if (v instanceof File) {
                return Node_Path.concat([ v.value0.dirname, label()(v) ]);
            };
            if (v instanceof Dir) {
                return Node_Path.concat([ v.value0.dirname, v.value0.basename ]);
            };
            throw new Error("Failed pattern match at Indexer.FSEntry (line 42, column 11 - line 42, column 97): " + [ v.constructor.name ]);
        };
        return Data_Ord.compare(Data_Ord.ordString)(toCompare(f1))(toCompare(f2));
    };
});
var encodeFile = new Foreign_Generic_Class.Encode(function (v) {
    if (v instanceof Dir) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("type")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("dir")), Data_Tuple.Tuple.create("basename")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.basename)), Data_Tuple.Tuple.create("dirname")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.dirname)), Data_Tuple.Tuple.create("content")(Foreign_Generic_Class.encode(Foreign_Generic_Class.arrayEncode(encodeFile))(v.value0.content)) ]));
    };
    if (v instanceof File) {
        return Foreign_Generic_Class.encode(Foreign_Generic_Class.objectEncode(Foreign_Generic_Class.foreignEncode))(Foreign_Object.fromFoldable(Data_Foldable.foldableArray)([ Data_Tuple.Tuple.create("type")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)("file")), Data_Tuple.Tuple.create("basename")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.basename)), Data_Tuple.Tuple.create("dirname")(Foreign_Generic_Class.encode(Foreign_Generic_Class.stringEncode)(v.value0.dirname)), Data_Tuple.Tuple.create("mtime")(Foreign_Generic_Class.encode(Indexer_MTime.encodeMTime)(v.value0.mtime)), Data_Tuple.Tuple.create("size")(Foreign_Generic_Class.encode(Foreign_Generic_Class.numberEncode)(v.value0.size)) ]));
    };
    throw new Error("Failed pattern match at Indexer.FSEntry (line 55, column 1 - line 71, column 6): " + [ v.constructor.name ]);
});
var decodeFile = new Foreign_Generic_Class.Decode(function (v) {
    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("type"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v1) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("basename"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v2) {
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("dirname"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.stringDecode)))(function (v3) {
                if (v1 === "dir") {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("content"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.arrayDecode(decodeFile))))(function (v4) {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Dir({
                            basename: v2,
                            dirname: v3,
                            content: v4
                        }));
                    });
                };
                if (v1 === "file") {
                    return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("mtime"))(Foreign_Generic_Class.decode(Indexer_MTime.decodeMTime)))(function (v4) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign)(Foreign_Index.indexString)(v)("size"))(Foreign_Generic_Class.decode(Foreign_Generic_Class.numberDecode)))(function (v5) {
                            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new File({
                                basename: v2,
                                dirname: v3,
                                mtime: v4,
                                size: v5
                            }));
                        });
                    });
                };
                return Foreign.fail(Foreign.ForeignError.create("invalid type: " + v1));
            });
        });
    });
});
module.exports = {
    Dir: Dir,
    File: File,
    unwrapFile: unwrapFile,
    label: label,
    genericFSEntry: genericFSEntry,
    showFSEntry: showFSEntry,
    ordFSEntry: ordFSEntry,
    eqFSEntry: eqFSEntry,
    encodeFile: encodeFile,
    decodeFile: decodeFile
};
